/**
 * The **Heading facts** about where each `[node]` heading's `parent=` placed it. The tree builder
 * seats what it can, and these name what Godot refuses. Only the linter reads them.
 */
import { emptyParentHeadings, rootDeclaringParent } from '../parser/instantiateRefusal.js';
import { isReRooted, isSeatedAtOwnPathIn, orphanedNodes, } from '../parser/sceneTreeBuilder.js';
import { connectionEndResolver } from '../parser/connectionEnd.js';
import { idTrailEnd } from '../parser/idTrail.js';
/**
 * The placement facts of one scan: `origins` is every `[node]` heading in scan order, and `seating`
 * the tree built from them.
 */
export function placementFacts(origins, seating) {
    const orphans = orphanedNodes(origins, seating);
    return {
        orphanedNodes: orphans,
        reRootedNames: reRootedNames(orphans, seating),
        seatedOrphans: new Set(orphans.filter(({ node }) => seating.seated.has(node))),
        rootWithParent: rootDeclaringParent(origins),
        emptyParentHeadings: emptyParentHeadings(origins),
        idRecoveries: idRecoveries(origins, seating),
        resolveConnectionEnd: connectionEndResolver(origins, seating),
    };
}
/**
 * The orphans whose `parent_id_path=` Godot follows to a node (`packed_scene.cpp:161-163`).
 * An orphan the trail does not recover is absent: Godot re-roots it.
 */
function idRecoveries(origins, seating) {
    const { seated, pathOf } = seating;
    const isPlaced = isSeatedAtOwnPathIn(seating);
    const recoveries = new Map();
    origins.forEach((origin, index) => {
        if (isPlaced(origin))
            return;
        const end = idTrailEnd(origins, index, isPlaced);
        if (!end)
            return;
        const via = origins[end.heading];
        recoveries.set(origin, { kind: end.kind, via, viaPath: pathOf.get(seated.get(via.node)) });
    });
    return recoveries;
}
function reRootedNames(orphaned, { seated }) {
    const names = new Map();
    for (const origin of orphaned) {
        const seat = seated.get(origin.node);
        if (seat && isReRooted(seat))
            names.set(origin, seat.name);
    }
    return names;
}
//# sourceMappingURL=placementFacts.js.map